import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { HasUnreadNotifications } from '../../types/user/userProfile'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useHasUnreadNotifications() {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { fetcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
  }

  const hasUnreadNotifications =
    async (): Promise<HasUnreadNotifications | null> => {
      setLoading(true)

      try {
        const data = await fetcher<HasUnreadNotifications>(
          `${CONFIG.BOUNCE_API}/api/v1/notifications/has-unread`
        )

        setError(null)

        return data
      } catch (error) {
        console.error(error)

        if (error instanceof ApiError) {
          setError(getErrorMessage(error.data))
        } else {
          setError(t('exceptions:unknown'))
        }

        return null
      } finally {
        setLoading(false)
      }
    }

  return {
    hasUnreadNotifications,
    loading,
    error,
    resetState,
  }
}
